import { Check, X } from "lucide-react"

interface Props {
  /** Compact mode shows fewer items — for inline use in forms */
  compact?: boolean
}

const DOS = [
  "The residence, campus, or building where artists stay",
  "Studios, workshops, or creative workspaces",
  "The surrounding town, city, or landscape",
  "Community moments — open studios, studio visits, group dinners, critiques",
  "Natural, well-lit photographs that feel authentic",
]

const DONTS = [
  "Graphics, logos, or images with overlaid text",
  "Stock photos that feel generic or staged",
  "Low-resolution or heavily filtered images",
  "Screenshots, flyers, or promotional materials",
]

export function PhotoGuidelines({ compact = false }: Props) {
  const dosList = compact ? DOS.slice(0, 3) : DOS
  const dontsList = compact ? DONTS.slice(0, 2) : DONTS

  return (
    <div className="border border-[var(--border)] rounded-xl p-4 bg-[var(--secondary)]/30">
      <p className="text-xs font-semibold uppercase tracking-wide text-[var(--muted-foreground)] mb-3">
        Photo Guidelines
      </p>
      <div className={compact ? "space-y-2" : "grid grid-cols-1 sm:grid-cols-2 gap-4"}>
        <div>
          <p className="text-xs font-medium text-emerald-700 mb-1.5 flex items-center gap-1">
            <Check size={12} /> Do show
          </p>
          <ul className="space-y-1">
            {dosList.map((item) => (
              <li key={item} className="text-xs text-[var(--muted-foreground)] leading-relaxed flex items-start gap-1.5">
                <span className="text-emerald-500 mt-0.5 shrink-0">&bull;</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className={compact ? "mt-2" : ""}>
          <p className="text-xs font-medium text-red-700 mb-1.5 flex items-center gap-1">
            <X size={12} /> Don&apos;t use
          </p>
          <ul className="space-y-1">
            {dontsList.map((item) => (
              <li key={item} className="text-xs text-[var(--muted-foreground)] leading-relaxed flex items-start gap-1.5">
                <span className="text-red-400 mt-0.5 shrink-0">&bull;</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {!compact && (
        <p className="text-[10px] text-[var(--muted-foreground)] mt-3 leading-relaxed">
          Listings with quality photos that follow these guidelines are approved faster
          and get more engagement from the community.
        </p>
      )}
    </div>
  )
}
